<!--
 * @Author: zl
 * @Date: 2022-09-15 15:24:13
 * @LastEditTime: 2022-09-16 14:56:53
 * @LastEditors: zl
 * @Description: 审计意见单
-->
<template>
	<div class='AuditOpinion-layout'>
		<el-row>
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">审 计 意 见 单</h2>
				<el-descriptions :column="2"
								 size="small"
								 border
								 class="custom-descriptions">
					<el-descriptions-item label="工程项目名称"
										  :span="2">
						{{ currentObj.proName }}
					</el-descriptions-item>
					<el-descriptions-item label="关联审计任务"
										  :span="2">{{ form.taskName }}</el-descriptions-item>
					<el-descriptions-item label="被审计 (调查) 单位或个人"
										  :span="2">{{ form.beAuditer }}</el-descriptions-item>
					<el-descriptions-item label="审计 (调查) 事项"
										  :span="2">{{ form.auditMatters }}</el-descriptions-item>
					<el-descriptions-item label="审计 (调查) 事项摘要"
										  :span="2"
										  contentClassName="h200">{{ form.content }}</el-descriptions-item>
					<el-descriptions-item label="上传附件"
										  :span="2">
						<myUpload listType="list"
								  tableName="audit_view_bill"
								  uploadType="2"
								  assortment="testrecord"
								  width="auto"
								  height="auto"
								  :aid="form.id"
								  mode="view"
								  class="h100 w100"></myUpload>
					</el-descriptions-item>
					<el-descriptions-item label="审计人员">{{ form.auditerName }}</el-descriptions-item>
					<el-descriptions-item label="编制日期">{{ form.redactDateStr }}</el-descriptions-item>
					<el-descriptions-item label="相关单位签收及意见"
										  :span="2"
										  contentClassName="pd0">
						<el-descriptions :column="2"
										 size="small"
										 border
										 style="margin: -2px"
										 class="custom-descriptions sp-descriptions">
							<el-descriptions-item label="建设单位备注">{{ form.consContent }}</el-descriptions-item>
							<el-descriptions-item label="监理单位备注">{{ form.supContent }}</el-descriptions-item>
							<el-descriptions-item label="建设单位">{{ form.constructUnitName }}</el-descriptions-item>
							<el-descriptions-item label="监理单位">{{ form.supUnit }}</el-descriptions-item>
							<el-descriptions-item label="负责人">{{ form.consPrincipal }}</el-descriptions-item>
							<el-descriptions-item label="负责人">{{ form.supPrincipal }}</el-descriptions-item>
							<el-descriptions-item label="签收日期">
								{{ form.consSignDate ? form.consSignDate.substr(0,10) : '' }}
							</el-descriptions-item>
							<el-descriptions-item label="签收日期">
								{{ form.supSignDate ? form.supSignDate.substr(0,10) : '' }}
							</el-descriptions-item>

							<el-descriptions-item label="施工单位备注">{{ form.roadContent }}</el-descriptions-item>
							<el-descriptions-item label="其他相关单位备注">{{ form.otherContent }}</el-descriptions-item>
							<el-descriptions-item label="施工单位">{{ form.roadUnit }}</el-descriptions-item>
							<el-descriptions-item label="其他相关单位">{{ form.otherUnitName }}</el-descriptions-item>
							<el-descriptions-item label="负责人">{{ form.roadPrincipal }}</el-descriptions-item>
							<el-descriptions-item label="负责人">{{ form.otherPrincipal }}</el-descriptions-item>
							<el-descriptions-item label="签收日期">
								{{ form.roadSignDate ? form.roadSignDate.substr(0,10) : '' }}
							</el-descriptions-item>
							<el-descriptions-item label="签收日期">
								{{ form.otherSignDate ? form.otherSignDate.substr(0,10) : '' }}
							</el-descriptions-item>
						</el-descriptions>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.selectViewBillDetail({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
</style>